import React from 'react';
import Select from 'react-select';
import { AUTO_ADD_INFO_FOR } from '../../submitters-field-element-settings';

// Whose date of hire a date field is auto-filled with: AUTO_ADD_INFO_FOR's initiator,
// submitter or submitter_2, absent for nobody's. The initiator's goes in on the
// initiation page, the submitter's when the form reaches them, Submitter 2's at
// step 2 of a strict order -- see init-form/elements/date-element.jsx.
export const HIRE_DATE_FOR_KEY = 'autoAddHireDateFor';

// Brings the date of hire forward to the initiation: Submitter 2's shows at step 1
// already (the one person step 2 names), and every recipient's copy carries it in its
// name when the field is attached to the form name (done on the backend). Nothing to
// bring forward for the initiator, who fills the form in at the initiation.
export const HIRE_DATE_ON_INITIATION_KEY = 'autoAddHireDateOnInitiation';

const HIRE_DATE_FOR_OPTIONS = [
  { value: AUTO_ADD_INFO_FOR.NONE, label: '----' },
  { value: AUTO_ADD_INFO_FOR.INITIATOR, label: 'Initiator' },
  { value: AUTO_ADD_INFO_FOR.SUBMITTER, label: 'Submitter' },
  { value: AUTO_ADD_INFO_FOR.SUBMITTER_2, label: 'Submitter 2' },
];

const canBeOnInitiation = (hireDateFor) => hireDateFor === AUTO_ADD_INFO_FOR.SUBMITTER || hireDateFor === AUTO_ADD_INFO_FOR.SUBMITTER_2;

const selectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9,
  }),
};

const HireDateSetting = ({ element, onChange }) => {
  const hireDateFor = element.options[HIRE_DATE_FOR_KEY];
  const activeOption = HIRE_DATE_FOR_OPTIONS.find((option) => option.value === hireDateFor) || HIRE_DATE_FOR_OPTIONS[0];
  const isOnInitiationEnabled = canBeOnInitiation(hireDateFor);

  const handleChange = (option) => {
    onChange(option.value === AUTO_ADD_INFO_FOR.NONE ? undefined : option.value, HIRE_DATE_FOR_KEY, element.id);

    // Only a refinement of whose date of hire goes in, so it goes with it.
    if (!canBeOnInitiation(option.value) && element.options[HIRE_DATE_ON_INITIATION_KEY]) {
      onChange(false, HIRE_DATE_ON_INITIATION_KEY, element.id);
    }
  };

  return (
    <div className="property-item">
      <h3 className="form-builder-aside-property-sub-title">Automatically add date-of-hire info for</h3>
      <div className="form-control-item">
        <Select
          className="form-control-select"
          classNamePrefix="react-select"
          value={activeOption}
          options={HIRE_DATE_FOR_OPTIONS}
          styles={selectStyles}
          onChange={handleChange}
        />
      </div>
      <div className="form-control-item d-block" style={{ marginTop: 8 }}>
        <div className="form-control-checkbox w-full">
          <input
            type="checkbox"
            disabled={!isOnInitiationEnabled}
            checked={Boolean(isOnInitiationEnabled && element.options[HIRE_DATE_ON_INITIATION_KEY])}
            onChange={() => {
              onChange(!element.options[HIRE_DATE_ON_INITIATION_KEY], HIRE_DATE_ON_INITIATION_KEY, element.id);
            }}
          />
          <span>As soon as the form is initiated</span>
        </div>
      </div>
    </div>
  );
};

export default HireDateSetting;
